import {
  CartBtn,
  SellModeCart,
  SellModeCategory,
  SellModeSearch,
  SellModeSideNav,
} from "../../components/secondaryComponents/SellModeItemsV2";
import styles from "./styles.module.scss";
import secondaryComponents from "../../components/secondaryComponents";
import { RavenPaymentTrigger } from "../../components/common";
import { Outlet, useNavigate, useParams } from "react-router-dom";
import primaryComponents from "../../components/primaryComponents";
import { AngleLeft, MapIcon } from "../../assets/svgIcons";
import { useState } from "react";
import { isCashierUser, isViaWebView, truncateString } from "../../helpers";
import { pathConstants } from "../../routes/pathContants";
import { useGetStoreDetails } from "../../hooks/api/queries";
import { DEFAULT_PRICING_ID } from "../../helpers/constants";
import { getActiveSubscription } from "../../services/settings";
import { useQueries } from "react-query";
import { SubscriptionToast } from "../../components/common/SubscriptionToast";
import useScanDetection from "use-scan-detection";
import { useSellModeFilters } from "../../hooks/useSellModeFilters";

export const SellModeLayoutV2 = () => {
  const { store_id } = useParams();
  const { filterBySearch } = useSellModeFilters();
  const { isLoading, data: storeDetails } = useGetStoreDetails(store_id);
  const [views, setViews] = useState({ isCart: false });
  const [pricingType, setPricingType] = useState(DEFAULT_PRICING_ID);
  const navigate = useNavigate();
  const [activeSubscription] = useQueries([
    {
      queryKey: ["activeSubscription"],
      staleTime: Infinity,
      queryFn: () => getActiveSubscription().then((res) => res?.data?.data),
    },
  ]);

  useScanDetection({
    minLength: 8,
    onComplete: (value) => {
      const cleanedValue = value
        // remove ALL control characters (ArrowUp, ESC, etc.)
        // eslint-disable-next-line no-control-regex
        .replace(/[\x00-\x1F\x7F]/g, "")
        .replace(/ArrowUp|ArrowDown|ArrowLeft|ArrowRight/g, "")
        .trim();

      if (cleanedValue) filterBySearch(cleanedValue, true);
    },
  });

  return (
    <>
      <secondaryComponents.LoaderHelper
        isLoading={isLoading || activeSubscription?.isLoading}
        classNames={"mt-5"}
      >
        <SubscriptionToast activeSubscription={activeSubscription?.data} />
        <div className={styles.sellModeLayoutV2}>
          <div className={styles.sellModeLayoutV2__left}>
            <header className={styles.header}>
              <div className={styles.header__top}>
                <span
                  className={`${styles.header__top__name} smallest-text-size`}
                >
                  <MapIcon
                    className="white--text mr-1"
                    style={{ fontSize: "15px" }}
                  />
                  {truncateString(storeDetails?.name, 35)}
                </span>
                <div className={styles.header__top__search}>
                  {!isViaWebView() && (
                    <primaryComponents.Button
                      classNames={"btn btn--outline"}
                      style={{ width: "46px", height: "46px" }}
                      onClick={() => {
                        const routePath = isCashierUser()
                          ? pathConstants.CASHIER_STORES
                          : pathConstants.STORES;
                        navigate(routePath);
                      }}
                    >
                      <AngleLeft className="font-weight-bold" />
                    </primaryComponents.Button>
                  )}

                  <SellModeSearch />
                </div>
              </div>

              <SellModeCategory />
            </header>

            <div className="d-flex">
              <div className={styles.sellModeLayoutV2__left__sidebar}>
                {window.screen.width > 650 ? <SellModeSideNav /> : null}
              </div>
              <div className={styles.sellModeLayoutV2__left__content}>
                <Outlet
                  context={{
                    pricingType,
                    setPricingType,
                    closeMobileCart: () =>
                      setViews((prev) => ({ ...prev, isCart: false })),
                  }}
                />
              </div>
            </div>
          </div>

          <div className={styles.sellModeLayoutV2__cart}>
            <SellModeCart />
          </div>
        </div>

        <span
          className={styles.cartBtn}
          role="button"
          onClick={() => setViews((prev) => ({ ...prev, isCart: true }))}
        >
          <CartBtn />
        </span>

        {/* Raven mounter */}
        {storeDetails?.support_raven_payment ? <RavenPaymentTrigger /> : null}
      </secondaryComponents.LoaderHelper>

      {/* stroe cart */}
      <secondaryComponents.Modal
        width={"100%"}
        isActive={views?.isCart}
        closeModal={() => setViews((prev) => ({ ...prev, isCart: false }))}
        style={{ padding: 0, borderRadius: 0, maxHeight: "100%" }}
      >
        <SellModeCart
          closeModal={() => setViews((prev) => ({ ...prev, isCart: false }))}
        />
      </secondaryComponents.Modal>
    </>
  );
};
